<template>
  <div>
    <div>
      <p>Заявка: <strong>{{ data.order.id }}</strong></p>
      <p>Клиент: <strong>{{ data.order.client_name || 'Не указан' }}</strong></p>
      <p>Телефоны:</p>
      <div class="flex" v-for="phone in data.order.order_phones">
        <span class="mr-2">{{ mixinPrintPhone(phone.phone.phone) }}</span>
        <MakeCall
          :order="data.order"
          :phone="{phone: phone.phone.phone, valid: true}"
        />
      </div>
      <p>Адрес: {{ data.order.address }}</p>
      <hr>
      <div class="row">
        <div class="col-md-6">
          <p v-for="drug in data.order.details">
            {{ drug.new_drug.title }} * <strong>{{ drug.qty }}</strong> * <strong>{{ drug.price }}</strong>
          </p>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="">Дата планируемой доставки</label>
            <OrderDateSelect
              ref="selectedDate"
              :disabled="true"
              :onSelect="date => (data.order.delivery_date = date)"
              :selectedDate="data.order.delivery_date"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import MakeCall from '@/components/orders/telephony/MakeCall';
import OrderDateSelect from '@/views/reports/components/OrderDateSelect';
import api from '@/api';
import store from "@/store";
import moment from "moment";
import {updateDynamicStoreData} from "@/eventsBus";

export default {
  props: ['data'],
  components: {
    MakeCall,
    OrderDateSelect,
  },
  methods: {
    async saveData(e = null, reject = false) {
      const sendData = {
        orderId: this.data.order.id,
        fields: {
          extra_text_action: reject ? 'Отменено согласование' : "Выполнено дополнительное согласование",
          is_agreed: !reject
        },
        // extra_options: {
        //   callDeal: !reject
        // }
      }
      if (!reject) {
        sendData.fields.delivery_date = moment(this.$refs.selectedDate.date).format("YYYY-MM-DD")
      }

      let {data} = await api.post("/orders/updateOrderByField", sendData)
      if (data.success) {
        await store.dispatch("orders/setUpdateOrder", {
          orderId: this.data.order.id,
          data: {
            // extra_options: {
            //   callDeal: !reject
            // }
            is_agreed: !reject
          }
        });
        updateDynamicStoreData.$emit(
          'updateDynamicStore',
          {
            drugsIds: this.data.order.details.map((d) => d.drug_id),
          }
        );
      }
      return data;
    }
  }
}
</script>
